import { BuildingContext } from "Context/BuildingProvider";
import { AuthContext } from "Firebase/AuthProvider";
import { useContext, useEffect, useState } from "react";
import { useTheme } from "styled-components";
import { useStyles } from "Theme/styles";
import {
  Box,
  LinearProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import PerfectScrollbar from "react-perfect-scrollbar";
import { getPrettyDateString } from "helpers/FormatHelper";
import { OnlineBuildingGuard } from "lib/realtimeDBTypes";

interface OnlineUsersTableProps {
  onlineBuildingGuards: OnlineBuildingGuard[];
}

interface OnlineUsersTableRow {
  guardName: string;
  currentStatus: string;
  since: string;
  priority: number;
  id: string;
}

interface OnlineUsersTableState {
  loading: boolean;
  tableRows: OnlineUsersTableRow[];
}

const DEFAULT_STATE: OnlineUsersTableState = {
  loading: true,
  tableRows: [],
};
export default function OnlineUsersTable({
}: OnlineUsersTableProps) {
  const [state, setState] = useState<OnlineUsersTableState>(DEFAULT_STATE);
  const { getDatabase } = useContext(AuthContext);
  const { currentBuilding, buildingState } = useContext(BuildingContext);
  console.log("🚀 ~ file: OnlineUsersTable.tsx ~ line 47 ~ buildingState", buildingState)
  const classes = useStyles();
  const theme = useTheme();

  useEffect(()=>{
    const onlineBuildingGuards = buildingState?.onlineBuildingGuards
    console.log("🚀 ~ file: OnlineUsersTable.tsx ~ line 51 ~ useEffect ~ onlineBuildingGuards", onlineBuildingGuards)
    const tableRows = [];
    if (
      typeof onlineBuildingGuards === "object" &&
      onlineBuildingGuards.length !== 0
    ) {
      for (const key in onlineBuildingGuards) {
        if (onlineBuildingGuards.hasOwnProperty(key)) {
          const onlineBuildingGuard = onlineBuildingGuards[key];

          const since = getPrettyDateString(onlineBuildingGuard.lastUpdateTime);
          const tableRow = {
            id: onlineBuildingGuard.buildingGuardId,
            guardName: onlineBuildingGuard.name,
            currentStatus: onlineBuildingGuard.status,
            since: since,
            priority: onlineBuildingGuard.priorityLevel,
          };
          tableRows.push(tableRow);
        }
      }
    }
    console.log(tableRows)
    setState({
      ...state,
      tableRows: tableRows,
      loading: false,
    });
  },[])
  useEffect(() => {
    const onlineBuildingGuards = buildingState?.onlineBuildingGuards
    console.log("🚀 ~ file: OnlineUsersTable.tsx ~ line 51 ~ useEffect ~ onlineBuildingGuards", onlineBuildingGuards)
    const tableRows = [];
    if (
      typeof onlineBuildingGuards === "object" &&
      onlineBuildingGuards.length !== 0
    ) {
      for (const key in onlineBuildingGuards) {
        if (onlineBuildingGuards.hasOwnProperty(key)) {
          const onlineBuildingGuard = onlineBuildingGuards[key];

          const since = getPrettyDateString(onlineBuildingGuard.lastUpdateTime);
          const tableRow = {
            id: onlineBuildingGuard.buildingGuardId,
            guardName: onlineBuildingGuard.name,
            currentStatus: onlineBuildingGuard.status,
            since: since,
            priority: onlineBuildingGuard.priorityLevel,
          };
          tableRows.push(tableRow);
        }
      }
    }
    console.log(tableRows)
    setState({
      ...state,
      tableRows: tableRows,
      loading: false,
    });
  }, [buildingState]);

  const loading = state.loading;
  if (loading) {
    return <LinearProgress />;
  } else {
    return (
      <Paper className="container">
        <PerfectScrollbar>
          <Box>
            <Typography color="textPrimary" variant="h4">
              Online Users
            </Typography>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Since</TableCell>
                  <TableCell>Priority</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {state.tableRows.map((tableRow: OnlineUsersTableRow) => (
                  <TableRow hover key={tableRow.id}>
                    <TableCell component="th" scope="row">
                      {tableRow.guardName}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {tableRow.currentStatus}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {tableRow.since}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {tableRow.priority}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </PerfectScrollbar>
      </Paper>
    );
  }
}
